var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseSlice',{staticClass:"gst-slice-form-embedded",attrs:{"slice-type":_vm.slice.slice_type,"slice-index":_vm.slice.index},scopedSlots:_vm._u([{key:"content",fn:function(){return [_c('div',{staticClass:"gst-slice__content",class:{
                'gst-slice__content--width-100': _vm.fullWidth,
                'gst-slice__content--height-100': _vm.fullHeight,
            },domProps:{"innerHTML":_vm._s(_vm.content)}})]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }